import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-strength-icon',
    templateUrl: './strength-icon.component.html',
    styleUrls: ['./strength-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StrengthIconComponent implements OnInit {

  @Input() exerciseId: any;
  constructor() { }

  ngOnInit(): void {
  }

}
